<div class="container-fluid container">
  <div class="row fun__main">
    <div class="fun__user-info">
      <div class="fun__mfa">
        <h1 class="fun__mfa__title" id="passcode-title" tabindex="0">Passcode</h1>
        <label class="fun__form__input-label fun__form__item" for="maskedPhoneNo" tabindex="0">
          Enter the code you received {{ maskedPhoneNo }}
        </label>
        <form
          [formGroup]="pinEntryForm"
          class="fun__form fun__form--inverse js-form"
          action=""
          autocomplete="off"
          aria-labelledby="passcode-title"
        >
          <div class="tabs">
            <div class="fun__form__row tab">
              <label class="fun__form__input-label fun__form__item" for="pin-input">
                <input
                  type="text"
                  id="pin-input"
                  class="fun__form__input js-form-input is-required"
                  formControlName="pin"
                  inputmode="numeric"
                  aria-required="true"
                  [attr.aria-label]="customError ? 'Please enter valid PIN number' : 'Enter the PIN you received'"
                  aria-describedby="pin-error pin-success"
                />
                <span>Enter PIN:*</span>
                <br />
                <div style="height: 40px">
                  <label *ngIf="customError" id="pin-error" class="text-danger" aria-live="assertive"
                    >Please enter valid PIN number</label
                  >
                  <label *ngIf="customSuccess" id="pin-success" class="text-success" aria-live="polite"
                    >PIN was resend successfully.</label
                  >
                </div>
              </label>
            </div>
          </div>
          <div class="tabs-button">
            <div class="fun__form__row fun__form__failure" role="alert"></div>
            <div class="fun__form__row tab">
              <button
                type="button"
                class="fun__button fun__button--arrow fun__button--btn-link fun__button--small js-form-submit"
                (click)="reSendCode()"
                aria-label="Resend the code"
              >
                Resend Code
              </button>
            </div>
            <div class="fun__form__row tab">
              <button
                type="button"
                id="validate-button"
                (click)="onSubmit()"
                class="fun__button fun__button--arrow fun__button--secondary fun__button--small js-form-submit validate"
                aria-label="Validate the entered PIN"
              >
                <span>Validate</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
